const Box = (char) => {
  const img = require(`../assets/Characters/${char.name}.png`);
  const ele = require(`../assets/Elements/${char.elements}.webp`);
  // const ele = char.element;
  const bg4 = require(`../assets/Background/Background_Item_4_Star.webp`);
  const bg5 = require(`../assets/Background/Background_Item_5_Star.webp`);

  return (
    <>
      <span className="ml-1 cursor-pointer select-none">
        <span
          className="inline-block hover:scale-110 mt-5 mr-1 mobile:mr-0.5 rounded-2xl bg-[#e2eff1] transition ease-in-out shadow-2xl"
          style={{
            borderTop: char.select ? "5px solid #00FFDD" : "",
            borderBottom: char.select ? "5px solid #00FFDD" : "",
            transition: "all .15s ease-in-out",
          }}
        >
          <img
            src={ele}
            alt=""
            draggable="false"
            loading="lazy"
            className="z-[2] float-left absolute rounded-tl-2xl w-[32px] h-[32px] mobile:w-[25px] mobile:h-[25px] m-[3px] select-none"
            style={{
              // width: "32px",
              // height: "32px",
              visibility:
                char.elements === "none" || char.elements == null
                  ? "hidden"
                  : "visible",
            }}
          />
          <img
            src={img}
            alt=""
            draggable="false"
            className="bgs rounded-t-2xl w-[133px] h-[130px] mobile:w-[90px] mobile:h-[90px] rounded-br-3xl relative z-[1] bg-center bg-no-repeat bg-cover select-none"
            style={{
              backgroundImage:
                char.rarity === 5 ? `url(${bg5})` : `url(${bg4})`,
            }}
          />
          <h1 className="text-[17px] mobile:text-[12px] text-center truncate w-[8.3rem] mobile:w-[90px]">
            {char.name}
          </h1>
        </span>
      </span>
    </>
  );
};

export default Box;
